import React from 'react';
import { FUNDING_DOCUMENT_STATUS_STYLES } from '../../utils/funding/constants';

const FundingDocumentStatusBadge = ({ status }) => {
  if (!status) return null;
  const className = FUNDING_DOCUMENT_STATUS_STYLES[status] || FUNDING_DOCUMENT_STATUS_STYLES.Missing;

  return (
    <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${className}`}>
      {status}
    </span>
  );
};

export default FundingDocumentStatusBadge;
